module.exports = __webpack_public_path__ + "static/media/pmarketing.7868fcd6.webp";